<template>
    <div class="container">
        <div class="row">
            <div class="col-sm-4 mb-2">
                <page-nav icn="fas fa-paper-plane text-primary" lab="応募履歴" @do_click="toApplyStatus"></page-nav>
            </div>
            <div class="col-sm-4 mb-2">
                <page-nav icn="fas fa-address-card text-primary" lab="契約情報" @do_click="toContract"></page-nav>
            </div>
            <!-- <div class="col-sm-4 mb-2"> -->
            <!--     <page-nav icn="fas fa-paper-plane text-primary" lab="応募一覧" @do_click="toApplyList"></page-nav> -->
            <!-- </div> -->
            <!-- <div class="col-sm-4 mb-2"> -->
            <!--     <page-nav icn="fas fa-business-time text-primary" lab="入場予定" @do_click="toEnterPlan"></page-nav> -->
            <!-- </div> -->
            <!-- <div class="col-sm-4 mb-2"> -->
            <!--     <page-nav icn="fas fa-id-card-alt text-success" lab="現場中" lab2="(now+1m<end)" @do_click="toWorking"></page-nav> -->
            <!-- </div> -->
            <!-- <div class="col-sm-4 mb-2"> -->
            <!--     <page-nav icn="fas fa-id-card-alt text-warning-cust" lab="更新待ち" lab2="(now+1m≧end)" @do_click="toUpdateWait"></page-nav> -->
            <!-- </div> -->
            <!-- <div class="col-sm-4 mb-2"> -->
            <!--     <page-nav icn="fas fa-id-card-alt text-danger" lab="退場待ち" lab2="(now≦end&&確定済)" @do_click="toExitWait"></page-nav> -->
            <!-- </div> -->
            <!-- <div class="col-sm-4 mb-2"> -->
            <!--     <page-nav icn="fas fa-id-card-alt text-muted" lab="退場済(確認待ち)" lab2="(now>end)" @do_click="toExited"></page-nav> -->
            <!-- </div> -->
            <!-- <div class="col-sm-4 mb-2"> -->
            <!--     <page-nav icn="fas fa-map-marked-alt text-primary" lab="場所(面接/入場)" @do_click="toPlace"></page-nav> -->
            <!-- </div> -->
        </div>
    </div>
</template>

<script>
    import PageNav from 'pages/commons/nav/PageNav'

    export default {
        components: {
            PageNav
        },
        methods: {
            toApplyStatus () {
                this.$store.dispatch('setRefreshArr', 'cmpApplyStatus')
                this.$router.push({name: 'ApplyStatus'})
            },
            toContract () {
                this.$store.dispatch('setRefreshArr', 'contractList')
                this.$router.push({name: 'Contract'})
            },
            // 以下廃棄
            toApplyList () {
                this.$store.dispatch('setRefreshArr', 'cmpApplys')
                this.$router.push({name: 'Apply'})
            },
            toEnterPlan () {
                this.$store.dispatch('setRefreshArr', 'enterPlan')
                this.$router.push({name: 'EnterPlan'})
            },
            // 現場中
            toWorking () {
                this.$router.push({name: 'WorkStatus', params: {do: 'working'}})
            },
            // 更新待ち
            toUpdateWait () {
                this.$router.push({name: 'WorkStatus', params: {do: 'updateWait'}})
            },
            // 退場待ち
            toExitWait () {
                this.$router.push({name: 'WorkStatus', params: {do: 'exitWait'}})
            },
            // 退場済み
            toExited () {
                this.$router.push({name: 'WorkStatus', params: {do: 'exited'}})
            },
            toPlace () {
                this.$store.dispatch('setRefreshArr', 'placeList')
                this.$router.push({name: 'IntvPlace'})
            }
        }
    }
</script>

<style lang="stylus" scoped>

</style>
